import { ResourceTypes } from 'api/moduleElement';
import { Variable, VariableType } from 'components/app-previews/common/variable';

type ResourceType = (typeof ResourceTypes)[keyof typeof ResourceTypes];

interface UIElement {
  position: number;
  resourcetype: Exclude<ResourceType, 'Container' | 'SectionDivider'>;
  variable_item?: { name?: string };
  variable_name?: string;
  panel_item?: {
    title?: string;
    name: string;
  }[];
}

export const getGroupVariables = (uiElements: UIElement[]): Variable[] => {
  uiElements.sort((a, b) => a.position - b.position);
  return uiElements
    .flatMap((uiElement) => {
      let variable: Partial<Variable> = {
        name: uiElement.variable_item?.name ?? uiElement.variable_name,
      };
      switch (uiElement.resourcetype) {
        case 'ChoicePanel':
          variable['type'] = 'Choice';
          break;
        case 'MultiChoicePanel':
          variable['type'] = 'Checkbox';
          break;
        case 'TextInput':
          variable['type'] = 'Text';
          break;
        case 'APIBox':
          variable['type'] = 'API';
          break;
        case 'GPTBox':
          variable['type'] = 'AI Output';
          break;
        case 'DescriptionPanel':
          variable['type'] = 'Message';
          break;
        case 'AmbientListening':
          variable['type'] = 'Scribe';
          break;
        case 'DataExtractor':
          variable['type'] = 'Data Extractor';
          break;
        case 'ValuePanel':
          return uiElement?.panel_item?.map((item) => ({
            type: 'Numbers' as VariableType,
            name: item.title || item.name,
          }));
        default:
          break;
      }
      return variable as Variable;
    })
    .filter((variable) => !!variable) as Variable[];
};
